import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['seat', 'warning'];
  static values = { assignedSeats: Number };

  checkValidity(event) {
    const input = event.target;
    const seatUpdateButton = document.getElementById('seat-update-btn');

    if (input.value < this.assignedSeatsValue) {
      input.classList.add('border','border-danger');
      this.warningTarget.classList.remove('d-none');
      this.warningTarget.classList.add('warning-added');
      seatUpdateButton.setAttribute('disabled', true);
    } else {
      input.classList.remove('border', 'border-danger');
      this.warningTarget.classList.add('d-none');
      this.warningTarget.classList.remove('warning-added');
    }

    if (!document.querySelector('.warning-added')) {
      seatUpdateButton.setAttribute('disabled', false);
      seatUpdateButton.removeAttribute('disabled');
    }
  }
}
